module.exports = __webpack_public_path__ + "img/security.cddbb874.png";